import type { SortState } from "../Revenue/sort"
import type { SortDir } from "../Revenue/types"
import type { ActualsRow } from "./components/ActualsTable"

export type ActualsSortKey = "actual" | "gm" | "units"

const VALUE: Record<ActualsSortKey, (row: ActualsRow) => number | null | undefined> = {
  actual: (r) => r.actual,
  gm: (r) => r.gm,
  units: (r) => r.units,
}

// The sort kept in the page link (?sort=gm&dir=asc). A key for a column the
// page does not show (GM% without the permission, units outside products)
// reads as no sort, so it comes back once the column does.
export function readSort(url: string, available: ActualsSortKey[]): SortState {
  const params = new URLSearchParams(url.split("?")[1] ?? "")
  const key = params.get("sort") as ActualsSortKey | null
  const dir: SortDir = params.get("dir") === "asc" ? "asc" : "desc"
  return key && available.includes(key) ? { sort: key, dir } : { sort: null, dir: "desc" }
}

export function sortQuery({ sort, dir }: SortState): { sort?: string; dir?: SortDir } {
  return sort ? { sort, dir } : {}
}

// Reorders rows by one column. Blank cells go to the bottom in both
// directions; equal values keep their order. No sort → input order.
export function sortActualsRows(rows: ActualsRow[], { sort, dir }: SortState): ActualsRow[] {
  if (!sort) return rows
  const value = VALUE[sort as ActualsSortKey]
  const sign = dir === "asc" ? 1 : -1
  return [...rows].sort((a, b) => {
    const x = value(a)
    const y = value(b)
    if (x == null || y == null) return (x == null ? 1 : 0) - (y == null ? 1 : 0)
    return sign * (x - y)
  })
}
